/* eslint-disable import/prefer-default-export */

import { createSelector } from 'reselect';
import getSafe from '../utils/getSafe';

export const getSuggestions = (state) => getSafe(() => state.location.places.suggestions) || [];

export const getHasSuggestions = createSelector(
  [getSuggestions],
  (suggestions) => suggestions.length > 0,
);
